import React from 'react';
import { Home } from 'lucide-react';
export function Footer() {
  return <footer className="bg-brand-dark text-gray-400 py-12 mt-auto" data-id="element-30">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-31">
        <div className="flex flex-col md:flex-row justify-between items-center md:items-start gap-6 mb-8 border-b border-gray-600 pb-8" data-id="element-32">
          <span className="text-2xl font-bold text-white tracking-tight" data-id="element-33">
            Rapid Home Lending Inc
          </span>

          <div className="text-center md:text-right text-sm" data-id="element-34">
            <p data-id="element-35">30700 Telegraph Rd, Suite 4600</p>
            <p data-id="element-36">Bingham Farms, MI 48025</p>
            <p className="mt-2" data-id="element-37">Company NMLS #1798321</p>
          </div>
        </div>

        <div className="text-xs space-y-4 text-gray-500 text-center md:text-left" data-id="element-38">
          <p data-id="element-39">
            <strong className="text-gray-400" data-id="element-40">Disclaimer:</strong> The
            information provided on this dashboard is for informational purposes
            only and does not constitute a loan offer or a commitment to lend.
            All estimates regarding refinance eligibility, potential interest
            rates, monthly savings, and cash-out amounts are based on automated
            valuation models and current market trends, which are subject to
            change without notice.
          </p>
          <p data-id="element-41">
            Actual loan terms, rates, and available cash-out amounts will depend
            on a complete review of your credit profile, property appraisal, and
            other underwriting criteria. Please contact your Loan Officer for an
            official Loan Estimate and to discuss your specific financial
            situation.
          </p>
          <div className="flex items-center justify-center md:justify-start gap-2 pt-4 text-gray-400" data-id="element-42">
            <Home className="w-5 h-5" data-id="element-43" />
            <span data-id="element-44">Equal Housing Opportunity</span>
          </div>
        </div>
      </div>
    </footer>;
}